<template><div></div></template>

<script>
import { mapActions, mapGetters } from 'vuex';
import MoveManager from '@/utils/components/MoveManager.vue';
import offersHelper from '@/utils/helpers/offers';

export default {
  name: 'configLoader',
  extends: MoveManager,
  data() {
    return {
      isLoading: true,
      forceReloadOnCreate: true,
      isDisplayMoverPhotos: false,
      forceGetOffer: false,
    };
  },
  computed: {
    ...mapGetters({
      offers: 'offerStore/offers',
      demand: 'demandStore/demand',
      projectSelected: 'projectStore/projectSelected',
      servicesStore: 'serviceStore/services',
    }),
  },
  methods: {
    ...mapActions({
      getDemand: 'demandStore/getDemand',
      getOffers: 'offerStore/getOffers',
      getServices: 'serviceStore/getServices',
      setConfig: 'configStore/setConfig',
      getOffer: 'offerStore/getOffer',
    }),
    checkAuthorization() {
      return true;
    },
    async loadConfig(forceReload, forceGetOffer, checkAuth) {
      this.isLoading = true;
      if (forceReload || (this.offers && !this.offers.length)) {
        await this.getOffers(this.isDisplayMoverPhotos);
      }
      if (forceReload || !this.demand) {
        await this.getDemand();
      }
      // TODO add get services
      // if (forceReload || !this.servicesStore) {
      //   await this.getServices(this.exclTax);
      // }

      const offerId = this.$route.params.id;
      let offer = this.offers.find(({ id }) => id === offerId);
      if (!offer) {
        if (offerId) {
          this.$router.push({ name: 'comparator' });
          return;
        }
        const mostAdvanced = offersHelper.getMostAvanced(this.offers);
        offer = mostAdvanced && mostAdvanced.length === 1 && mostAdvanced[0];
      }

      if (forceGetOffer && offerId) {
        const result = await this.getOffer({
          token: this.projectSelected && this.projectSelected.token,
          id: offerId,
          isDisplayMoverPhotos: this.isDisplayMoverPhotos,
        }).catch(() => {
          this.$router.push({ name: 'comparator' });
          return false;
        });
        if (result === false) {
          return;
        }
        this.setConfig(result);
      } else {
        this.setConfig(offer || null);
      }
      this.isLoading = checkAuth
        ? !this.checkAuthorization()
        : false;
    },
  },
  watch: {
    async projectSelected() {
      try {
        await this.loadConfig(true);
      // eslint-disable-next-line no-empty
      } catch (e) {}
    },
  },
  async created() {
    try {
      await this.loadConfig(this.forceReloadOnCreate, this.forceGetOffer, true);
    // eslint-disable-next-line no-empty
    } catch (e) {}
  },
};
</script>
